/**
 * Splits the action of a menu-drawer row in two: the label navigates to the
 * group's own page, the caret opens the child list.
 *
 * Capture phase, and stopPropagation, are both load-bearing. MenuDrawerDetails
 * (header.js) binds its own click listener directly to the <summary>, which
 * slides the submenu in 100ms later. A bubble-phase listener runs after that
 * one, so the panel would start sliding, stall, and only then navigate. Capture
 * on document runs before any listener on the summary, and stopping propagation
 * there means the theme never sees the click at all.
 *
 * preventDefault() handles the other half: a <summary> toggles its <details> for
 * a click anywhere inside it, nested <a> included. With the default cancelled we
 * navigate by hand.
 */
document.addEventListener(
  'click',
  (event) => {
    const label = event.target.closest('[data-apc-mdrawer-label]');
    if (!label) return;

    const href = label.getAttribute('href');
    if (!href) return;

    // Leave modified clicks alone so open-in-new-tab still works.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = href;
  },
  true
);
